<template>
	<div>
		<el-steps :active="3" id="steps">
			<el-step title="上传文件"></el-step>
			<el-step title="数据确认"></el-step>
			<el-step title="初始化成功"></el-step>
		</el-steps>
		<div class="success-content">
			<i class="el-icon-success"></i>
			<h3>初始化成功</h3>
			<p>已成功上传{{count}}条数据</p>
			<a href="javascript:;">{{totalTime}}秒后自动跳转到初始化列表</a>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				totalTime:3,
				count:'',
			};
		},
		mounted() {
			this.countDown();
		},
		methods: {
			countDown() {
				this.count = this.$route.query.count;
				let url = this.$route.query.url
				let clock = window.setInterval(() => {
					this.totalTime--
					if (this.totalTime == 1) { 
						window.clearInterval(clock);
						window.location.href = url;
					}
				}, 1000)
			}
		}
	}
</script>

<style scoped>
	.success-content {
		text-align: center;
		margin-top:100px;
	}
	.success-content a{
		color:#01c0c8;
		text-decoration: none;
		font-size:14px;
	}
	.success-content h3{
		font-size:22px;
		margin-bottom:15px;
	}
	.success-content p{
		font-size:14px;
		margin-bottom:25px;
		color:#cecece;
	}
	.success-content i{
		color:#1ddd46;
		font-size:80px;
	}
</style>
